/* eslint-disable */
import {
  Card, Col,
  Row,
  Space,
  Typography
} from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TimekeepingProps {
  name?: string;
  fromDate?: string;
  endDate?: string;
}

const TimekeepingDetail: React.FC<TimekeepingProps> = ({
  endDate,
  fromDate,
  name,
}) => {
  /* Hooks */
  const { t } = useTranslation();

  /* Render */
  return (
    <Row gutter={16}>
      <Col>
        <Card
          title={(
            <Typography.Title level={4}>
              {t('timesheet.timekeepingPeriod')}
            </Typography.Title>
          )}
        >
          <div className="site-card-border-less-wrapper">
            <Space
              direction="vertical"
              size={12}
              style={{ width: '100%' }}
            >
              <Row gutter={16}>
                <Col sm={12} xl={8} className="u-mt-8">
                  <Typography.Text>
                    {t('timesheet.timeKeepingName')}
                    {': '}
                  </Typography.Text>
                  <div>
                    <Typography.Text strong>
                      {name}
                    </Typography.Text>
                  </div>
                </Col>
                <Col sm={12} xl={8} className="u-mt-8">
                  <Typography.Text>
                    {t('timesheet.fromDate')}
                    {': '}
                  </Typography.Text>
                  <div>
                    <Typography.Text strong>
                      {fromDate ? dayjs(fromDate).format('DD/MM/YYYY') : ''}
                    </Typography.Text>
                  </div>
                </Col>
                <Col sm={12} xl={8} className="u-mt-8">
                  <Typography.Text>
                    {t('timesheet.endDate')}
                    {': '}
                  </Typography.Text>
                  <div>
                    <Typography.Text strong>
                      {endDate ? dayjs(endDate).format('DD/MM/YYYY') : ''}
                    </Typography.Text>
                  </div>
                </Col>
              </Row>
            </Space>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default TimekeepingDetail;
